import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Spinner } from '..'

export default function MainLayout() {
  return (
    <Suspense fallback={<Spinner fullScreen={true} />}>
      <Outlet />
    </Suspense>
  )
}
